﻿import $ from 'jquery';
import { IRemoteHandler, IRemoteOptions } from "./remote";
import Ajax from "./ajax";
import RequestVerificationToken from "../../utilities/requestverificationtoken";
import _ from "underscore"

export class FormInputRemoteHandler implements IRemoteHandler {
    public handle($element: JQuery, options: IRemoteOptions): boolean {
      var $form = this.findForm($element);
      var shouldHandle = ($element.is('form') || this.isSubmit($element)) && $element.isEnabled() && $form.length != 0;
      if (!shouldHandle)
        return false;

      options.$triggeringEvent?.preventDefault();

      options.type = options.type || $element.data('method') || $form.attr('method') || 'post';
      options.url = options.url || $element.data('url') || $form.attr('action');

      if ($element.is('button[type="submit"]')) {
        this.addOrUpdateHiddenInputForSubmitButton($element, $form);
      }

      if (!options.data)
        options.data = {};

      if (!options.data['__RequestVerificationToken']) {
        var token = new RequestVerificationToken();
        options.data[token.key] = token.value;
      }

      $form.trigger('formdatacollecting.rustig.remote');
      let data = $.extend({}, options.data, this.serializeFormToJSON($form));
      options.data = this.transformJsonToString(data);

      $form.trigger('remotesubmit.rustig.remote');
      Ajax.execute($element, options);
      return true;
    }

    private findForm($element: JQuery) {
      let $result = $element.closest('form');
      let hasRemoteTargetForm = this.isSubmit($element) && $element.is('form'.asDataSelector());

      if ($result.length == 0 && hasRemoteTargetForm) {
        let targetFormId = $element.data('form');
        $result = $('form-id'.asDataSelector(targetFormId));
      }

      return $result;
    }

    private addOrUpdateHiddenInputForSubmitButton($button: JQuery, $form: JQuery): void {
      var name = $button.attr('name');
      if (!name)
        return;

      var value = $button.val();
      var $input = $form.find('input[name="' + name + '"]');
      if ($input.length == 0) {
        $input = $('<input>').attr('type', 'hidden')
          .attr('name', name)
        $form.prepend($input);
      }
      $input.val(value);
    }

    private serializeFormToJSON($form: JQuery): any {
      var arr = $form.serializeArray();
      var data = _(arr).reduce((acc, field: any) => {
        if (acc[field.name] && field.value == "false")
          return acc;

        var currentProperty = acc[field.name];
        if (currentProperty !== undefined) {
          if ($.isArray(currentProperty))
            acc[field.name].push(field.value);
          else
            acc[field.name] = [currentProperty, field.value];
        }
        else
          acc[field.name] = field.value;

        return acc;
      }, {});
      return data;
    }

    private transformJsonToString(jsonObject: any): any {
      var result = "";

      for (var key in jsonObject) {
        if ($.isArray(jsonObject[key])) {
          var arrayData = _(jsonObject[key]).reduce((acc, prop: any) => {
            acc += '&' + key + '=' + encodeURIComponent(prop);
            return acc;
          }, "");
          result += arrayData;
        }
        else {
          result += '&' + key + '=' + encodeURIComponent(jsonObject[key]);
        }
      }

      return result.length > 0 ? result.substring(1) : result;
    };

    private isSubmit($element: JQuery): boolean {
      return $element.is('[type="submit"]') || $element.is('submit'.asDataSelector());
    }

  }
